import React from "react";
import { useTranslations } from "next-intl";

interface Props {
  status: string;
}

const StatusBadge: React.FC<Props> = (props) => {
  const t = useTranslations()
  return (
    <div className="px-[12px] h-[30px] rounded-[10px] bg-[#ECECECbf] flex items-center justify-center">
      <span className="text-[#444444] font-normal text-[13px]">
        {t(`status.${props.status}`)}
      </span>
    </div>
  );
};

export default StatusBadge;
